import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Profile from './components/Profile';
import Photos from './components/Photos';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Header from './components/Header';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Online from './components/Online';
import Diet from './components/Diet';
import Advice from './components/Advice';
import Offline from './components/Offline';


function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<>
            <Profile />
            <Online />
            <Advice />
            <Photos />
            <Offline />
            <Diet />
          </>} />
          {/* <Route path="/onlineclub" element={<Online />} />
          <Route path="/dietplanning" element={<Diet />} />
          <Route path="/workout" element={<Advice />} />
        <Route path="/Offlineclub" element={<Offline />} /> */}
        <Route path="/contactus" element={<Contact />} />
        </Routes>
        <Footer />
      </BrowserRouter>

    </div>
  );
}

export default App;
